import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { PaginationDefaults } from '../../../shared/utils/pagination-defaults.util';
import { axiosInstance } from '../../shared/api/axios-instance';
import { LocalStorageProperties } from '../../shared/enums/local-storage-properties.enum';
import { StatesEnum } from '../../shared/enums/states.enum';
import localStorageService from '../../shared/services/local-storage/local-storage.service';
import { castTo } from '../../shared/utils/cast-to';
import { createQueryParams } from '../../shared/utils/create-query-params/create-query-params.util';
import { AppDto } from '../dtos/app.dto';
import { AppTableModel } from '../models/app-table.model';
import { AppsHeaderAndPaginationFilters } from '../models/apps-header-and-pagination-filters.model';
import { mapAppDtoToAppTableModel } from '../utils/mapping.utils';

export const getApps: AsyncThunk<
  AppTableModel[],
  Partial<AppsHeaderAndPaginationFilters> | undefined,
  Record<string, unknown>
> = createAsyncThunk(
  'apps/get',
  async (
    filters: Partial<AppsHeaderAndPaginationFilters> | undefined
  ): Promise<AppTableModel[]> => {
    const mandantId = localStorageService.get(
      LocalStorageProperties.SELECTED_MANDANT
    ) as string | null;

    const queryParams = createQueryParams({
      ...filters?.header,
      ...(filters?.header?.status && {
        status: castTo<StatesEnum>(filters?.header?.status.toUpperCase()),
      }),
      size: filters?.pagination?.size
        ? filters.pagination.size
        : PaginationDefaults.size,
      offset: filters?.pagination?.offset
        ? filters.pagination.offset
        : PaginationDefaults.offset,
      ...(mandantId !== null && { mandant: parseInt(mandantId, 10) }),
    });

    const basePath = '/apps' + queryParams;

    const { data }: AxiosResponse<AppDto[]> = await axiosInstance.get(
      basePath,
      {
        headers: {
          'Accept-Encoding': 'gzip',
        },
      }
    );

    return data.map(mapAppDtoToAppTableModel);
  }
);
